<template>
    <v-card
      class="ma-0 pa-3"
      height="255"
    >
      <v-container
        class="pa-0 d-flex justify-space-between align-center mb-4"
      >
        <v-card-text class="text-body-2 pa-0">{{ $t('Comparison of cost and payment') }}</v-card-text>
        <div class="d-flex gap-2">
          <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="secondary"
              outlined
              v-bind="attrs"
              v-on="on"
              custom
            >
              <svg width="17" height="17" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 8L3.5 5.5L4.2 4.775L5.5 6.075V2H6.5V6.075L7.8 4.775L8.5 5.5L6 8ZM3 10C2.725 10 2.48967 9.90217 2.294 9.7065C2.09833 9.51083 2.00033 9.27533 2 9V7.5H3V9H9V7.5H10V9C10 9.275 9.90217 9.5105 9.7065 9.7065C9.51083 9.9025 9.27533 10.0003 9 10H3Z" fill="#030303"/>
              </svg>
            </v-btn>
          </template>
          <v-list v-if="items != null && items != undefined && items.length > 0 && $store.getters.getpermission && $store.getters.getpermission.includes('overview')">
            <v-list-item @click="exportChart('png')">
              <v-list-item-title>
                <v-card-text class="pa-0 text-body-2">{{ $t('PNG-image') }}</v-card-text>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportChart('pdf')">
              <v-list-item-title>
                <v-card-text class="pa-0 text-body-2">{{ $t('PDF-file') }}</v-card-text>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportChart('excel')">
              <v-list-item-title>
                <v-card-text class="pa-0 text-body-2">{{ $t('EXCEL-file') }}</v-card-text>
              </v-list-item-title>
            </v-list-item>
          </v-list>
          </v-menu>
          <v-select
            :items="days"
            :label="$t('date')"
            dense
            outlined
            append-icon="mdi-chevron-down"
            item-text="name"
            item-value="value"
            v-model="selectedDate"
            @change="selectDate"
            style="width: 130px;"
            :class="{ 'dltr' : !$vuetify.rtl}"
            :style="{ 'direction' : !$vuetify.rtl ? 'rtl' : ''}"
          >
          </v-select>
        </div>
      </v-container>
      <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
        <apexchart
          v-if="items != null && items != undefined && items.length > 0"
          type="line"
          :options="lineChartOptions"
          :series="lineChartSeries"
          width="100%"
          height="195"
          ref="chartComponent"
        />
        <div
          v-if="items != null && items != undefined && items.length == 0 && !loading"
          style="margin-top: 26px;"
        >
          <div class="d-flex justify-center align-center">
            <img src="@/assets/dashboard/no-data(1).png" style="width: 120px;" />
          </div>
          <div class="d-flex justify-center align-center mt-5">
            <v-card-text class="pa-0 text-caption text-center">
              {{ $t('there is no enough information for showing.') }}
            </v-card-text>
          </div>
        </div>
        <v-container
          v-if="loading"
          class="pa-0 d-flex justify-center align-center"
        >
          <v-progress-circular
            :width="3"
            color="blue"
            indeterminate
          />
        </v-container>
      </div>
      <div v-else style="margin-top: 26px;">
        <div class="d-flex justify-center align-center">
          <img src="@/assets/dashboard/not-access(1).png" style="width: 120px;" />
        </div>
        <div class="d-flex justify-center align-center mt-5">
          <v-card-text class="pa-0 text-caption text-center">
            {{ $t("you don't have access to this information") }}
          </v-card-text>
        </div>
      </div>
    </v-card>
</template>

<script>
import jsPDF from "jspdf" // PDF export
import * as XLSX from "xlsx"

export default {
  data () {
    return {
      items: [],
      days: [
        {
          name: this.$t('one-week-ago'),
          value: '7days'
        },
        {
          name: this.$t('two-week-ago'),
          value: '14days'
        },
        {
          name: this.$t('one-month-ago'),
          value: '30days'
        }
      ],
      selectedDate: '7days',
      loading: false,
      lineChartOptions: {
        chart: {
          height: 195,
          type: 'line',
          toolbar: {
            show: false
          },
          fontFamily: 'IRANSans'
        },
        xaxis: {
          categories: [],
          axisBorder: {
            show: false // Hide the X-axis line
          },
          axisTicks: {
            show: false // Optional: Hide the ticks on the X-axis
          }
        },
        yaxis: {
          labels: {
            offsetX: this.$vuetify.rtl ? -70 : 0,
            floating: false
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        markers: {
          width: 12,
          height: 12,
          shape: 'square'
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          show: true
        },
        colors: [
          '#4CAF50',
          '#FF9800',
          '#0066FF',
          '#7C4DFF',
          '#00CAE3',
          '#E91E63',
          '#FF5252'
        ]
      },
      // Data for the line chart (two datasets)
      lineChartSeries: []
    }
  },
  methods: {
    fetchList () {
      if (this.items == []) {
        this.loading = true
      }
      var app = this
      app.$axios.get(this.$endpoint + 'widgets', {
        params: {
          type: 'CompareCostByPay',
          dateType: this.selectedDate
        }
      })
        .then(r => {
          this.loading = false
          this.items = r.data
          this.lineChartOptions = {
            ...this.lineChartOptions,
            xaxis: {
              categories: this.items.map(item => item.key),
              labels: {
                rotate: 0,
                style: {
                  fontSize: '10px'
                },
                show: true
              }
            },
            yaxis: {
              labels: {
                show: true,
                style: {
                  fontSize: '10px'
                },
                offsetX: this.$vuetify.rtl ? -65 : 0,
                formatter: (value) => {
                  /* return this.$numberFormat(value) */
                  return `${this.$numberFormat(value)} ${this.$store.state.currency.name}`
                }
              }
            }
          }
          this.lineChartSeries = [
            {
              name: this.$t('cost'),
              data: this.items.map((item) => parseFloat(item.cost)),
            },
            {
              name: this.$t('payment'), 
              data: this.items.map((item) => parseFloat(item.pay)),
            },
          ]
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
        })
    },
    selectDate (value) {
      this.selectedDate = value
      this.fetchList()
    },
    async exportChart(format) {
    const chartRef = this.$refs.chartComponent?.chart;
    if (!chartRef) {
        console.error("Chart instance not available.");
        return;
    }

    try {
        // Create a temporary chart container for export
        const tempChartContainer = document.createElement("div");
        document.body.appendChild(tempChartContainer);

        // Extract the original chart options
        const clonedOptions = {
            ...chartRef.w.config,
            chart: { 
                type: chartRef.w.config.chart.type, 
                animations: { enabled: false },
                toolbar: { show: false } // Hide the toolbar during export
            },
            xaxis: { ...chartRef.w.config.xaxis },
            yaxis: { 
                ...chartRef.w.config.yaxis,
                labels: { 
                  formatter: (val) => `${this.$numberFormat(val)} ${this.$store.state.currency.name}` 
                }
            }
        };

        const tempChart = new ApexCharts(tempChartContainer, clonedOptions);

        // Render the temporary chart
        await tempChart.render();

        // Export based on format
        if (format === "png" || format === "svg") {
            const { imgURI } = await tempChart.dataURI({
                width: 300,   // Smaller width (reduce to desired size)
                height: 200,  // Smaller height (reduce to desired size)
                scale: 0      // Scale set to 1 for regular resolution
            });
            this.downloadImage(imgURI, `chart-export.${format}`);
        } else if (format === "pdf") {
            await this.exportToPDF(tempChart);
        } else if (format === "excel") {
            await this.exportToExcel();
        }

        // Safeguard: Ensure the chart and container are removed properly
        if (tempChartContainer && tempChartContainer.parentNode) {
            try {
                tempChart.destroy();
                tempChartContainer.parentNode.removeChild(tempChartContainer);
            } catch (cleanupError) {
                console.error("Error during cleanup:", cleanupError);
            }
        }

    } catch (error) {
        console.error("Export failed:", error);
    }
    },
    downloadImage(uri, filename) {
      const link = document.createElement("a");
      link.href = uri;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async exportToPDF(tempChart) {
    try {
        // Generate PNG image from the chart
        const { imgURI } = await tempChart.dataURI({
            width: 600,  // Adjust the width as needed
            height: 400, // Adjust the height as needed
            scale: 1     // Normal resolution
        });

        // Create a new PDF document
        const pdf = new jsPDF({ orientation: "landscape" });

        // Add the chart image to the PDF
        pdf.addImage(imgURI, "PNG", 20, 20, 250, 140); // Adjust positioning as needed

        // Optionally, add a title or any other content to the PDF
        pdf.setFontSize(12);
        pdf.text("Chart Export", 20, 180);  // Title text
        pdf.text("Chart data and values are included below:", 20, 190);  // Subtitle

        // Optionally, you can add chart data below the image (for example)
        const chartOptions = tempChart.w.config;
        const chartSeries = chartOptions.series;
        const categories = chartOptions.xaxis.categories;

        let yPosition = 200; // Start position for chart data text
        chartSeries.forEach((series, index) => {
            pdf.text(`${series.name}:`, 20, yPosition);
            yPosition += 10;
            series.data.forEach((dataPoint, i) => {
                pdf.text(` ${categories[i]} - ${dataPoint}`, 30, yPosition);
                yPosition += 6;
            });
        });

        // Save the PDF
        pdf.save("chart-export.pdf");

    } catch (error) {
        console.error("Export to PDF failed:", error);
    }
    },
    exportToExcel() {
      // Use lineChartSeries and lineChartOptions
      const headers = [this.$t('date'), ...this.lineChartSeries.map(series => series.name)];

      const rows = this.lineChartOptions.xaxis.categories.map((category, index) => {
        return [
          category,
          ...this.lineChartSeries.map(series => {
            const value = series.data[index] ?? ""; // Get data value for each series
            return value !== "" ? value.toFixed(2) : ""; // Force two decimal places for numbers
          })
        ]
      })

      // Create a worksheet with the formatted data
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

      // Apply custom number format to all cells with numeric data (to avoid scientific notation)
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = { r: row, c: col };
          const cell = worksheet[XLSX.utils.encode_cell(cellAddress)];

          if (cell && !isNaN(cell.v)) {
            // Format numeric cells to display as full numbers (not scientific notation)
            cell.z = "#,##0.00";  // Custom format (can adjust the number of decimals)
          }
        }
      }

      // Create a workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Chart Data");

      // Generate an Excel file and trigger download
      XLSX.writeFile(workbook, "chart-export.xlsx");
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.v-tab {
  flex-direction: column;
  gap: .3rem;
}
::v-deep .v-tabs-bar {
  height: 80px;
}
::v-deep .v-tabs-slider-wrapper {
  top: 0;
}
::v-deep .v-slide-group__content {
  gap: 5rem;
}
::v-deep .v-window.v-item-group {
  margin-top: 20px;
}
::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding: 0 4px 0 0 !important;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-label.v-label {
  font-size: 11px !important;
}
::v-deep .v-icon.v-icon {
  font-size: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
::v-deep .apexcharts-legend-marker {
  width: 12px !important;
  height: 12px !important;
  border-radius: 0 !important;
  margin-left: 3px !important;
}
::v-deep .apexcharts-legend .apexcharts-legend-series {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
::v-deep .apexcharts-legend .apexcharts-legend-series:first-child {
  margin-right: 0 !important;
}
::v-deep .apexcharts-legend {
  padding: 0;
}
::v-deep .v-input .v-input__control .v-label.v-label--active  {
    right: 7px !important;
}
::v-deep .v-input.dltr .v-input__control .v-label.v-label--active  {
    left: 13px !important;
}
</style>
